if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.initPreorderButton();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const pairEle = this.form.querySelector('input[name="properties[_custompair]"]');
              var pairId = "";
              var costId = "";
              if (pairEle) {
                pairId = pairEle.value;
              }              
              const costEle = this.form.querySelector('input[name="properties[_customcostid]"]');
              if(costEle) costId = costEle.value;
              console.log(pairEle, pairId);
              if(pairEle && pairId.length > 0) {
                var VID = Number(costId);
                var addData = {
                    'id':VID,
                    'quantity':1,
                    'properties': {
                      ['_pair']: pairId
                    }
                };

                const cartRef = this.cart;
                // Open drawer immediately with first product response
                this.cart.renderContents(response);

                fetch('/cart/add.js', {
                  body: JSON.stringify(addData),
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With':'xmlhttprequest'
                  },
                  method: 'POST'
                }).then(function(response1) {
                  return response1.json();
                }).then(function(response2) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: VID,
                    cartData: response2,
                  });
                  // Re-fetch fresh cart sections to get correct totals after pair added
                  return fetch(window.location.pathname + '?section_id=cart-drawer');
                }).then(function(res) {
                  return res.text();
                }).then(function(html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  var newDrawer = doc.querySelector('#CartDrawer');
                  var currentDrawer = document.querySelector('#CartDrawer');
                  if (newDrawer && currentDrawer) {
                    currentDrawer.innerHTML = newDrawer.innerHTML;
                  }
                  // Update cart icon bubble too
                  fetch(window.location.pathname + '?section_id=cart-icon-bubble')
                    .then(function(r) { return r.text(); })
                    .then(function(bubbleHtml) {
                      var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
                      var newBubble = bubbleDoc.querySelector('.shopify-section');
                      var currentBubble = document.getElementById('cart-icon-bubble');
                      if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
                    });
                }).catch(function(err) {
                  console.error(err);
                });
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      initPreorderButton() {
        const preorderBtn = this.querySelector('.product-form__preorder');
        if (!preorderBtn) return;

        preorderBtn.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (preorderBtn.getAttribute('aria-disabled') === 'true' || preorderBtn.disabled) return;

          preorderBtn.setAttribute('aria-disabled', true);
          preorderBtn.classList.add('loading');
          const spinner = preorderBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          const variantId = preorderBtn.dataset.variantId;
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.headers['Content-Type'] = 'application/json';

          const addData = {
            id: Number(variantId),
            quantity: 1,
            properties: {
              'Type': 'Précommande'
            }
          };

          if (this.cart) {
            addData.sections = this.cart.getSectionsToRender().map((section) => section.id);
            addData.sections_url = window.location.pathname;
          }

          config.body = JSON.stringify(addData);

          if (this.cart) {
            this.cart.setActiveElement(document.activeElement);
          }

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return;
              }
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
              this.cart.renderContents(response);
            })
            .catch((e) => console.error(e))
            .finally(() => {
              preorderBtn.classList.remove('loading');
              preorderBtn.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            });
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
